module.exports = __webpack_public_path__ + "static/media/icon-supplies-robe.cc668ff4.svg";